import React from 'react';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';

import Fdms from './components/Fdms/Fdms';
import WorldPay from './components/WorldPay/WorldPay';
import Xpay from './components/Xpay/Xpay';

type Props = DepositResult & DepositContext & { updateFdmsStatus: () => void };

export enum Psp3ds2ProcessorType {
  WORLDPAY = 'WORLDPAY',
  FDMS = 'FDMS',
  XPAY = 'XPAY'
}

export enum DDCStatus {
  ddcOk = 'ddcOk',
  ddcError = 'ddcError',
  ddcTimeout = 'ddcTimeout'
}

const RejectedX3dSecure2RequiredError: React.FC<Props> = ({
  deposit,
  previousDeposit,
  updateFdmsStatus,
  ...depositResult
}) => (
  <>
    {depositResult.processor === Psp3ds2ProcessorType.FDMS && (
      <Fdms updateFdmsStatus={updateFdmsStatus} {...depositResult} />
    )}
    {depositResult.processor === Psp3ds2ProcessorType.WORLDPAY && <WorldPay {...depositResult} />}
    {depositResult.processor === Psp3ds2ProcessorType.XPAY && (
      <Xpay deposit={deposit} previousDeposit={previousDeposit} {...depositResult} />
    )}
  </>
);

export default RejectedX3dSecure2RequiredError;
